/* EmojiPickerNoResults.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu85zaO%7Bgap%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2NHnM%7Bpadding-top%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxb5zaO%7Bpadding-right%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWNHnM%7Bpadding-bottom%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q5zaO%7Bpadding-left%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fwxA5DIqT%7Btext-align%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
import { useCallback, type MouseEvent } from 'react';
import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';
import { fg } from '@atlaskit/platform-feature-flags';
import { FormattedMessage } from 'react-intl';
import AkButton from '@atlaskit/button/standard-button';
import { messages } from '../i18n';
import SearchNoResultDark from './assets/spot/search-no-result/SearchNoResultDark';
import SearchNoResultLight from './assets/spot/search-no-result/SearchNoResultLight';
const noResultsContainer = null;
export const RENDER_EMOJI_PICKER_NO_RESULTS_TESTID = 'render-emoji-picker-no-results';
export interface Props {
  onOpenUpload: () => void;
  uploadEnabled: boolean;
}
const EmojiPickerNoResults = ({
  onOpenUpload,
  uploadEnabled
}: Props): JSX.Element => {
  const {
    colorMode
  } = useThemeObserver();
  const handleOpenUpload = useCallback((event: MouseEvent<HTMLElement>) => {
    if (fg('platform_emoji_keep_picker_open_on_upload')) {
      event.preventDefault();
      event.stopPropagation();
    }
    onOpenUpload();
  }, [onOpenUpload]);
  return <div data-testid={RENDER_EMOJI_PICKER_NO_RESULTS_TESTID} className={ax(["_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _0Of8r2NHnM _1Znuxb5zaO _1wydGWNHnM _2Zuz6Q5zaO _2fwxA5DIqT _39xV02N91d _24h04i2Njc"])}>
			{colorMode === 'dark' ? <SearchNoResultDark /> : <SearchNoResultLight />}
			{uploadEnabled && <FormattedMessage {...messages.emojiPickerAddCustomEmoji}>
					{label => <AkButton onClick={handleOpenUpload} appearance="default" tabIndex={0}>
							{label}
						</AkButton>}
				</FormattedMessage>}
		</div>;
};
export default EmojiPickerNoResults;